<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <taskSelect v-model="filters.etid" :lists.sync="taskLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">项目：</div>
        <adSelect v-model="filters.adid" :lists.sync="adLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">下家：</div>
        <adChnSelect v-model="filters.acid" :lists.sync="adChnLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">用户ID：</div>
        <el-input v-model="filters.euid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">快递单号：</div>
        <el-input v-model="filters.express_id" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">地址：</div>
        <el-input v-model="filters.address" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="filters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="600">
      <el-table-column prop="eeid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="etid" label="广告" width="" align="center" sortable>
        <template slot-scope="scope">
          <div>{{scope.row.title}}({{scope.row.etid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="euid" label="用户ID" width="" align="center">
        <template slot-scope="scope">
          <div >{{scope.row.nickname}}({{scope.row.euid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" width="" align="center">
      </el-table-column>
      <el-table-column prop="adid" label="广告ID" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.ad_title}}({{scope.row.adid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="acid" label="下家ID" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.chn_name}}({{scope.row.acid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="express_id" label="快递单号" width="" align="center">
      </el-table-column>
      <el-table-column prop="address" label="地址" width="" align="center">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="" align="center" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1">运行</div>
          <div v-if="scope.row.status == 0">失效</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <button class="blue-small-btn" @click="editDetail(scope.$index)">编辑</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="分类编辑" :visible.sync="detailDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">ID</div>
            <el-input v-model="detail.eeid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">快递单号</div>
            <el-input type="textarea" :rows="1" v-model="detail.express_id" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">地址:</div>
            <el-input type="textarea" :rows="8" v-model="detail.address" placeholder="请求回复" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">状态</div>
            <el-radio-group v-model="detail.status">
              <div class="dib mr-20">
                <el-radio :label="0">失效</el-radio>
                <el-radio :label="1">运行</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="earnExpressEdit">保存</div>
          <div class="gray-large-btn" @click="detailDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import util from '../../../script/util'
import mixinList from '../../../mixins/list'
import {earnExpressLists, earnExpressEdit} from '../../../api/api'
import adSelect from '../../../components/data-select/adSelect.vue'
import taskSelect from '../../../components/data-select/taskSelect.vue'
import adChnSelect from '../../../components/data-select/adChnSelect.vue'
export default {
  name: 'earnExpress',
  mixins: [mixinList],
  components: {
    adSelect,
    taskSelect,
    adChnSelect
  },
  data () {
    return {
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '运行',
          value: 1
        },
        {
          name: '停止',
          value: 0
        }
      ],
      lists: [],
      listLoading: false,
      taskLists: [],
      adChnLists: [],
      adLists: [],
      filters: {
        p: 1,
        l: 20,
        total: 0,
        euid: '',
        etid: '',
        title: '',
        acid: '',
        express_id: '',
        address: '',
        status: ''
      },
      detailDialog: false,
      detail: {
        eeid: 0,
        etid: '',
        express_id: '',
        address: '',
        status: 1
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    editDetail (index) {
      this.detailDialog = true
      for (let key in this.detail) {
        this.detail[key] = this.lists[index][key]
      }
    },
    earnExpressEdit () {
      let params = {
        eeid: this.detail.eeid,
        express_id: this.detail.express_id,
        address: this.detail.address,
        status: this.detail.status
      }

      earnExpressEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.detailDialog = false
          this.getList()

          for (let key in this.detail) {
            this.detail[key] = ''
          }
          this.detail.eeid = 0
          this.detail.status = 1
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.etid !== '') {
        params.etid = filters.etid
      }

      if (filters.euid !== '') {
        params.euid = filters.euid
      }

      if (filters.adid !== '') {
        params.adid = filters.adid
      }

      if (filters.acid !== '') {
        params.acid = filters.acid
      }

      if (filters.express_id !== '') {
        params.express_id = filters.express_id
      }

      if (filters.address !== '') {
        params.address = filters.address
      }

      if (filters.status !== '') {
        params.status = filters.status
      }

      this.listLoading = true
      earnExpressLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.notifyError('服务器出错了')
      })
    },
    filterParamsChange () {
      this.filters.p = 1
      this.getList()
    }
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.etid': 'filterParamsChange',
    'filters.euid': 'filterParamsChange',
    'filters.title': 'filterParamsChange',
    'filters.adid': 'filterParamsChange',
    'filters.acid': 'filterParamsChange',
    'filters.express_id': 'filterParamsChange',
    'filters.address': 'filterParamsChange',
    'filters.status': 'filterParamsChange'
  },
  mounted () {
    this.getList()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/module/earn/earnExpress.vue